import { useHistory } from "react-router-dom";

const EPuapSuccess = () => {

    const history = useHistory();

    const goToMainPage = () => {
        history.push("/")
    }


    return (
        <>
            <div className="container options">
                <p className="h1 mainHeaderTitle mb-5">
                    Dziękujemy za złożenie deklaracji
                </p>
                <p className="w-100 text-center">
                    Deklaracja została przekazna na elektroniczną skrzynkę podawczą Urzędu Miasta we Wrocławiu
                </p>
                <div className="d-flex justify-content-center">

                    <button className="btn-primary w-50" onClick={() => { goToMainPage(); }}>

                        Wróć do strony głównej
                    </button>

                </div>

            </div>
        </>
    );
};

export { EPuapSuccess };
